<div *ngIf="!isListMode">
  <div *ngIf="!display">
    <div class="content-wrapper">
      <div class="btn-wrapper">
        <button mat-flat-button class="btn-back btn-warn" color="" aria-label="Back" (click)='back()'>
          <span>{{'questions.typeOfQuestions.surveyLikeDislike.btnBack' | translate}}</span>
        </button>
        <span class="spacer"></span>
        <button [disabled]="surveyLikeDislikeForm.invalid" mat-flat-button color="" class="btn-primary" aria-label="Save" (click)="saveQuestion()">
          <span>{{'questions.typeOfQuestions.surveyLikeDislike.btnSave' | translate}}</span>
        </button>
      </div>
      <div>
        <form [formGroup]="surveyLikeDislikeForm">
          <ng-container>
            <div class="filter-section">
              <div class="body-section title">
                <mat-icon>library_add</mat-icon> &nbsp;
                <span>{{'questions.typeOfQuestions.surveyLikeDislike.title' | translate}}</span>
              </div>
            </div>
            <div class="editor1" formGroupName="questiondescription">
              <label class="que-label">{{'questions.typeOfQuestions.surveyLikeDislike.labelQuest' | translate}}</label>
              <ckeditor #myEditor formControlName="description" [editor]="Editor" (click)="onClick(true)" (ready)="onReady($event)"></ckeditor>
              <div *ngIf="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
              <!-- <ckeditor formControlName="description" data="Enter here..." [config]="ckeditorConfig" [ngClass]="{'ckeditor-loading': isCkeditorLoading}" (ready)="onCkeditorReady()"></ckeditor> -->
            </div>
          </ng-container>
          <div *ngIf="addOptionEditor==true" class="text-msg">
            <span>Please add the question first</span>
          </div>
          <div class="exp-panel">
            <mat-accordion>
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    {{'questions.typeOfQuestions.surveyLikeDislike.accordian.title' | translate}}
                  </mat-panel-title>
                </mat-expansion-panel-header>

                <div class="container-fluid">
                  <div class="row">
                    <div class="col-md-2 answers-label">
                      <div class="form-label">
                        <label>{{'questions.typeOfQuestions.surveyLikeDislike.accordian.selectOptions.option1.label' | translate}}</label>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <mat-form-field class="scoring-type" appearance="fill">
                        <mat-select formControlName="questiondisplayoptions">
                          <mat-option [value]="option.title" *ngFor="let option of QuestionOrientation">{{option.title}}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </mat-expansion-panel>
            </mat-accordion>
          </div>
        </form>
      </div>
    </div>
  </div>

  <div *ngIf="display">
    <app-choose-question-type></app-choose-question-type>
  </div>
</div>

<div *ngIf="isListMode">
  <app-question-list></app-question-list>
</div>
